export default {"src":"/_next/static/media/robot-slateus.603ded13.svg","height":100,"width":100};